export const StarsRating = ({ rating }: { rating: number }) => {
  return (
    <div>
      {[1, 2, 3, 4, 5].map((i, idx) => {
        return (
          <i key={idx} className={`${i <= rating ? "las" : "lar"} la-star`} />
        );
      })}
    </div>
  );
};
